import { FC } from 'react'
import Typography from 'components/Typography'
import styles from './SearchTitle.module.scss'

export type TProps = {
  loading?: boolean
  total?: number | null
  title?: string
  location?: string
}

const SearchTitleSkeleton = () => (
  <svg
    width="100%"
    height="46"
    data-testid="searchTitleSkeleton"
    className={styles.ecTitleSkeleton}
  >
    <rect x="0" y="15" rx="4" ry="15" width="220" height="16" />
  </svg>
)

const SearchTitle: FC<TProps> = ({ total = 0, title, location, loading }) => {
  if (loading) return <SearchTitleSkeleton />

  return (
    <div data-testid="ecSearchTitle">
      <strong>
        {total && total >= 10000 ? '+' : null}
        {total}
      </strong>
      <Typography as="h1" className={styles.ecSearchTitle}>
        {' '}
        {title}
        {location && (
          <span>
            {' '}
            em <strong>{location}</strong>
          </span>
        )}
      </Typography>
    </div>
  )
}

export default SearchTitle
